<script lang="ts">
	import type { LayoutData } from './$types';
	import { page } from '$app/stores';
	import Error404 from '$lib/components/errors/Error404.svelte';
	import Error500 from '$lib/components/errors/Error500.svelte';

	export let data: LayoutData;
</script>

{#if $page.status === 404 || $page.status === 410}
	<Error404 locale={data.locale} />
{:else}
	<Error500 locale={data.locale} />
{/if}
